import { createStyles, makeStyles } from '@mui/styles';
import { Colors } from 'copyright-clearance-center-common-ui';

const useStyles = makeStyles(() =>
	createStyles({
		root: {
			display: 'flex',
			flexDirection: 'column',
			padding: '1rem 1.5rem 0.75rem 1.5rem',
			gap: '0.25rem',
			borderBottom: `solid 1px ${Colors.neutral300}`
		}
	})
);

export interface IHeaderContainerProps {
	children?: React.ReactNode;
}

const HeaderContainer: React.FunctionComponent<IHeaderContainerProps> = ({ children }) => {
	const classes = useStyles();

	return <div className={classes.root}>{children}</div>;
};

export default HeaderContainer;
